import Service from "../Service";
import Vue from "vue";
const resource = "TasAgriculturalEquipment/";

export default {
  pagination(parameters, requestID) {
    // console.log('Pafination', parameters, requestID);
    return Service.post(resource + "paginationDetail", parameters, {
      params: { requestID },
    });
  },
  save(advanceProducer, requestID) {
    return Service.post(resource + "saveDetail", advanceProducer, {
      params: { requestID },
    });
  },

};
